import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension, NCZIReference } from '../Interfaces/ncziTypes';

export type WritePatientVaccinationResultParams = PatientCommandParams & {
	vaccination: {
		createdAt: string;
		versionStatus: string;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		kind: NCZIReference;
		type: NCZIReference;
		note: string | undefined;
		dose: {
			sequence: number;
			totalCount: number;
			isLast: boolean;
		};
		executed: {
			dateTime: string;
			vaccine: {
				substance: NCZIExtension;
				note: string | undefined;
				batch: string;
				amount: {
					amount: string;
					unit: NCZIReference;
				};
			};
		};
	};
};

export const WritePatientVaccinationResult = (
	params: WritePatientVaccinationResultParams,
): Command => {
	return {
		operation: 'ZapisOckovanie',
		params,
	};
};
